export interface IJobCountState {
    TotalJobs?: number,
    AssignedJobs?: number,
    UnAssignedJobs?: number,
    CollectionCount?: number,
    CurationCount? : number
}



export enum IJobCountActionTypes {
    FETCH_JOB_COUNT_DETAILS_REQUEST = 'FETCH_JOB_COUNT_DETAILS_REQUEST',
    FETCH_JOB_COUNT_DETAILS_SUCCESS = 'FETCH_JOB_COUNT_DETAILS_SUCCESS',
    FETCH_JOB_COUNT_DETAILS_FAILURE = 'FETCH_JOB_COUNT_DETAILS_FAILURE',

}

export type IJobCountActionCreator = {
    type: string;
    payload: IJobCountState;
  };

